// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperNewsStory-cls1_Il7","cls2":"PaperNewsStory-cls2_ZIS PaperNewsStory-cls1_Il7","variant-dense":"PaperNewsStory-variant-dense_eSF"};